'use client';

import ErrorPage from 'next/error';

export default function GlobalError({
  error: _error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <html lang="fr">
      <body>
        <ErrorPage statusCode={undefined as unknown as number} />
      </body>
    </html>
  );
}
